// Re-export singleton from lib/supabaseClient
export { supabase, getSupabase } from '../lib/supabaseClient';
export type { DbClient, DbOffer, DbOfferItem } from '../lib/supabaseClient';

console.log('✅ Using Supabase singleton from lib/supabaseClient');
